class Breadcrumb {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }

  event() {
    const mm = gsap.matchMedia();

    mm.add('(max-width: 768px)', () => {
      const breadEle = document.querySelector('.' + this.el + ' > nav');

      if (breadEle) {
        // 子要素を取得
        const children = breadEle.children;
        let totalWidth = 0;
        const gap = 9.6; // 0.6remはデフォルトで9.6px (1rem = 16pxと仮定)

        // 子要素の横幅を合計
        Array.from(children).forEach(child => {
          totalWidth += child.offsetWidth;  // 各子要素の横幅を加算
        });

        // gapの合計 (子要素がn個の場合、隙間はn-1個)
        const gapTotal = (children.length - 1) * gap;

        // 合計にgapの幅を加える
        totalWidth += gapTotal;

        breadEle.style.width = totalWidth + 'px';
        console.log('Total width of children including gaps:', totalWidth);
      }
    });
  }
}